import React, { forwardRef } from "react";
import styles from "./Years.module.scss";

interface YearsProps {
  yearLeft: number;
  yearRight: number;
}

export const Years = forwardRef<HTMLDivElement, YearsProps>(
  ({ yearLeft, yearRight }, ref) => {
    return (
      <div ref={ref} className={styles.years} aria-hidden="true">
        <div className={styles.yearLeft}>{yearLeft}</div>
        <div className={styles.yearRight}>{yearRight}</div>
      </div>
    );
  }
);

Years.displayName = "Years";

